import React from 'react';
import { Link } from 'react-router-dom';

function AsideMenuItem(props) {
    return (
        <Link className="aside-menu-item" to={props.to}>
            <span className="aside-mi-label">{props.label}</span>
            <div className="aside-mi-icon-container">
                {props.icon}
            </div>
        </Link>
    );
}

export default AsideMenuItem;